import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react-lite';

import { useActivateKeyMutation } from '../../../generated/graphql';
import LayoutSmall from '../../../layouts/LayoutSmall';
import { Store } from '../../../model/store/Store';
import { DOMAIN_CODE_SUCCESS } from '../../../routes';
import { codeRegex } from '../../../shared/regex';

import cls from '../Domain.module.scss'
interface IForm {
  code: string;
}

export const Code = observer(() => {

  const {t} = useTranslation()
  const store = useInstance(Store);
  const navigate = useNavigate();

  const [activateKey, {loading}] = useActivateKeyMutation()

  const onFinish = async ({code}: IForm) => {
    await activateKey({
        variables: {
            id: store.domain.selectedDomain!,
            code: code,
        },
        onCompleted: (data) => {
            if (data.activateKey?.done) {
                store.auth.needUpdate()
                navigate(DOMAIN_CODE_SUCCESS)
            }
        }
    })
  }
  
  return (
      <LayoutSmall title={t('Activation key')}>
        <div className={cls.page}>
          <Form layout="vertical" initialValues={{code: ''}} validateTrigger={'onFinish'} onFinish={onFinish} disabled={loading}>
            <Form.Item name={'code'} label={t('Key')} rules={[
                { required:true, message: `${t('Required')}`},
                { pattern: codeRegex, message: t('16 latin letters and digits')! },
            ]}>
              <Input placeholder={'A1B2C3D4E5F6G7H8'} />
            </Form.Item>
            <Form.Item>
              <Button loading={loading} type="primary" htmlType="submit" block>{t('Activate')}</Button>
            </Form.Item>
          </Form>
        </div>
      </LayoutSmall>
  )

})